var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_90899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z",
    fill: "#F8761F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18180_90899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4433 21.6456C28.4433 19.1702 26.6443 17.1201 24.2864 16.7589V14.4196C24.9466 14.1385 25.3499 13.5156 25.3499 12.7907C25.3499 11.8001 24.561 10.9722 23.5769 10.9722C22.5927 10.9722 21.8151 11.8001 21.8151 12.7907C21.8151 13.5156 22.2193 14.1385 22.8786 14.4196V16.7435C22.3154 16.8199 21.7701 16.9948 21.2675 17.2603C20.2259 16.4665 16.8352 14.0065 14.8969 12.5218C14.9452 12.3512 14.9705 12.175 14.9722 11.9977C14.9731 11.473 14.7655 10.9695 14.3952 10.5978C14.0249 10.2261 13.5221 10.0167 12.9974 10.0156C12.4736 10.0178 11.9721 10.2277 11.6029 10.5993C11.2337 10.9709 11.027 11.4739 11.0283 11.9977C11.0262 12.5222 11.2324 13.026 11.6017 13.3985C11.9709 13.7709 12.473 13.9815 12.9974 13.9838C13.3668 13.9838 13.7102 13.8737 14.0083 13.6955L20.1643 18.0508L20.1627 18.05C19.6754 18.5126 19.2876 19.0696 19.023 19.6872C18.7584 20.3047 18.6225 20.9697 18.6237 21.6416C18.6237 22.7537 18.9898 23.7791 19.6046 24.6029L17.7376 26.4935C17.5685 26.4311 17.3897 26.399 17.2094 26.3987C16.802 26.3987 16.4205 26.5583 16.1346 26.8466C15.8478 27.135 15.6899 27.5222 15.6899 27.9328C15.6899 28.3435 15.8486 28.7266 16.1346 29.015C16.4213 29.3033 16.8061 29.4556 17.2103 29.4556C17.6177 29.4556 17.9992 29.3074 18.2892 29.015C18.4864 28.8167 18.6255 28.5682 18.6913 28.2965C18.7572 28.0247 18.7472 27.7401 18.6626 27.4736L20.5491 25.5676C21.4047 26.2316 22.4574 26.591 23.5404 26.589C26.2515 26.589 28.4433 24.3753 28.4433 21.6456ZM23.5388 24.2611C22.1018 24.2611 20.9363 23.0882 20.9363 21.6416C20.9363 20.1949 22.101 19.022 23.5388 19.022C24.9757 19.022 26.1413 20.1949 26.1413 21.6416C26.1413 23.0882 24.9757 24.2611 23.5388 24.2611Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_90899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18180_90899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.44,
    height: 19.44,
    fill: "white",
    transform: "translate(10.0166 10.0156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/Hubspot.b4c30edf1f3f340403374a6c9102fcc0.svg";
export { ForwardRef as ReactComponent };